<hlm-dialog-content showCloseButton="false" class="finx-confirm-dialog">
  <div id="web-app" class="overlay-confirmation p-3 !bg-inherit !rounded-[inherit]">
    <header class="mb-4" *ngIf="localeValues">
      <div class="d-flex space-evenly mt-4" *ngIf="localeValues.title && localeValues.title.length > 0">
        <div class="text-center align-self-center">
          <h1>{{ localeValues.title }}</h1>
        </div>
      </div>
      <p *ngIf="reason" class="confirmation-reason typog-sm text-center">{{ reason }}</p>
    </header>

    <!-- Error Display -->
    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <!-- Code entry + masked destination subtitle + resend (shared with /confirmation-code) -->
    <div *ngIf="localeValues">
      <finxone-web-frontend-pin-boxes
        [(pin)]="pin"
        [error]="error"
        (pinBoxes)="checkPinComplete()"
        [confirmationType]="confirmation"
        [localeValues]="localeValues"
      ></finxone-web-frontend-pin-boxes>
    </div>

    <div class="w-100 d-flex mt-4">
      <input
        class="button buttonText secondaryButton w-100 mt-4"
        type="button"
        [value]="localeValues?.doBack || 'Cancel'"
        (click)="onCancel()"
      />
    </div>
  </div>
</hlm-dialog-content>
